import React, { useEffect, useReducer, useState } from "react";
import FilterListIcon from "@mui/icons-material/FilterList";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import {
  Box,
  CardHeader,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialButton from "../../../components/MaterialButton";
import Swal from "sweetalert2";

import Grid from "@mui/material/Grid2";
import { useLoading } from "../../../context/LodingContext";

import _ from "lodash";

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import { FileUploadModal } from "../../../components/uploadDialog/FileUploadModal";

import { useMutation } from "@apollo/client";
import { bulkUploadMallEntry } from "./api/mutation";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import MaterialBox from "../../../components/MaterialBox";

import MaterialSelect from "../../../components/MasterSelect";
import MaterialInput from "../../../components/MaterialInput";
import ProductDisplayComplianceNew from "./newUi";
import RoleAccess from "../../function/RoleAccess";
import { useAuthData } from "../../context/loginContext/LoginContextProvider";
const ProductDisplayCompliance = () => {
  const [rows, setrows] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const filterProductOptions = rows?.flatMap((row, index) => {
    if (!Array.isArray(row?.agreedProducts)) {
      return [];
    }
    return row.agreedProducts.map((product) => {
      return {
        value: product.product.productCategory,
        label: product.product.productCategory,
      };
    });
  });

  const [filter, setFilter] = useState({
    fromDate: "",
    toDate: "",
    agentId: "",
    productCategory: "",
  });

  const [UpdateFile] = useMutation(bulkUploadMallEntry);
  const [excelcells, setecxellcells] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { setCirleLoading } = useLoading();
  const [value, setValue] = React.useState("myentry");
  const [uploadStatus, setUploadStatus] = useState(false);
  const {  userDetails } = useAuthData();

  const handleChange = (event, newValue) => {
    setCurrentPage(1);
    setValue(newValue);
    resetFilters();
  };

  const downloadExcel = () => {
    // Convert JSON data to worksheet
    if (excelcells.length == 0) {
      return;
    }
    const worksheet = XLSX.utils.json_to_sheet(excelcells);
    const workbook = XLSX.utils.book_new();

    // Append worksheet to workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Write to buffer
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    // Create a Blob from the buffer
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Trigger file download
    saveAs(blob, "exported_data.xlsx");
  };

  const handleExcelUpload = async (file) => {
    setUploadStatus(false);
    setCirleLoading(true);
    try {
      const response = await UpdateFile({
        variables: {
          file: file,
        },
        context: { hasUpload: true },
      });

      const res = response?.data?.bulkUploadMallEntry?.success;
      const message = response?.data?.bulkUploadMallEntry?.message;

      if (res) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        }).then(() => {
          // fetchtodaydata();
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
    } catch (error) {
      Swal.fire({
        position: "top",
        icon: "error",
        title: "File upload failed!",
        text: error.message,
        showConfirmButton: true,
      });
    } finally {
      setCirleLoading(false);
    }
  };

  const resetFilters = () => {};

  const handleUploadClick = () => {
    setUploadStatus(false); // reset first
    setTimeout(() => setUploadStatus(true), 0);
  };

  const handleFilterSubmit = () => {
    setDialogOpen(false);
    const filteredRows = rows.filter((row) => {
      const { fromDate, toDate, agentId, productCategory } = filter;

      // Convert filter dates only once if provided
      const from = fromDate ? new Date(fromDate) : null;
      const to = toDate ? new Date(toDate) : null;

      const createdAt = new Date(row.createdAt);

      const matchesDate =
        (!from || createdAt >= from) && (!to || createdAt <= to);

      const matchesAgent = !agentId || row.agent === agentId?.value;

      const matchesProductCategory =
        !productCategory ||
        row.agreedProducts?.some(
          (product) =>
            product.product.productCategory === productCategory?.value
        );

      return matchesDate && matchesAgent && matchesProductCategory;
    });

    setrows(filteredRows);
  };

  return (
    <DashboardLayout>
      <CardHeader
        title={
          <>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Product display Compliance List
                </MaterialTypography>
              </Stack>
              <RoleAccess
                modelName="Product Display Compliance Screen"
                component="CreateProductCompliance"
              >
                <MaterialButton
                  variant="gradient"
                  color="dark"
                  size="small"
                  startIcon={<AddIcon />}
                  onClick={() =>
                    navigate("/product-compliance/form", {
                      state: { type: "add" },
                    })
                  }
                >
                  Products Compliance
                </MaterialButton>
              </RoleAccess>
            </Stack>
            <Box sx={{ marginTop: "5px" }}>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
              >
                <Box sx={{ width: "50%", bgcolor: "background.paper" }}>
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    TabIndicatorProps={{
                      style: {
                        backgroundColor: "#2a9941",
                        color: "white",
                      },
                    }}
                    centered
                  >

                     {userDetails?.role?.role?.toLowerCase() == "admin" && (
                     <Tab
                        label="All Mall Entries"
                        value="allentry"
                        disabled={isLoading}
                      />
                      )}
                 
                      
                    
                      <Tab
                        label="Mall Assigned to me"
                        value="myentry"
                        disabled={isLoading}
                      />
              
                  </Tabs>
                </Box>

                <MaterialBox>
                  <Dialog
                    open={dialogOpen}
                    onClose={() => setDialogOpen(false)}
                    maxWidth="sm"
                    fullWidth
                  >
                    <DialogTitle>Filter List</DialogTitle>
                    <DialogContent>
                      <Grid container spacing={2}>
                        {/* Default Date Range Fields */}
                        <Grid size={{ xs: 12, sm: 6 }}>
                          <MaterialBox lineHeight={0} display="inline-block">
                            <MaterialTypography
                              component="label"
                              variant="caption"
                              fontWeight="bold"
                            >
                              From Date <span style={{ color: "red" }}>*</span>
                            </MaterialTypography>
                          </MaterialBox>
                          <MaterialInput
                            type="date"
                            name="fromDate"
                            value={filter?.fromDate}
                            onChange={(e) => {
                              const inputDate = e.target.value;
                              const today = new Date()
                                .toISOString()
                                .split("T")[0];

                              // Check if inputDate is not in the future
                              if (inputDate <= today) {
                                setFilter((prev) => ({
                                  ...prev,
                                  fromDate: inputDate,
                                }));
                              }
                              // Optionally, you can show an error or ignore invalid input
                            }}
                            inputProps={{
                              max: new Date().toISOString().split("T")[0], // max today
                            }}
                          />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                          <MaterialBox lineHeight={0} display="inline-block">
                            <MaterialTypography
                              component="label"
                              variant="caption"
                              fontWeight="bold"
                            >
                              To Date <span style={{ color: "red" }}>*</span>
                            </MaterialTypography>
                          </MaterialBox>
                          <MaterialInput
                            type="date"
                            name="toDate"
                            value={filter?.toDate}
                            onChange={(e) => {
                              const inputDate = e.target.value;
                              const today = new Date()
                                .toISOString()
                                .split("T")[0];
                              const minDate = filter?.fromDate;

                              // Allow only if toDate is between fromDate and today
                              if (
                                inputDate <= today &&
                                (!minDate || inputDate >= minDate)
                              ) {
                                setFilter((prev) => ({
                                  ...prev,
                                  toDate: inputDate,
                                }));
                              }
                            }}
                            inputProps={{
                              max: new Date().toISOString().split("T")[0], // max today
                              min: filter?.fromDate || undefined, // min fromDate
                            }}
                          />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                          <MaterialBox lineHeight={0} display="inline-block">
                            <MaterialTypography
                              component="label"
                              variant="caption"
                              fontWeight="bold"
                            >
                              Agent <span style={{ color: "red" }}>*</span>
                            </MaterialTypography>
                          </MaterialBox>
                          <MaterialSelect
                            value={filter?.agentId || ""}
                            onChange={(e) => {
                              setFilter((prev) => ({
                                ...prev,
                                agentId: e,
                              }));
                            }}
                            options={rows.map((row) => ({
                              value: row.agent,
                              label: row.agent,
                            }))}
                          />
                        </Grid>

                        <Grid size={{ xs: 12, sm: 6 }}>
                          <MaterialBox lineHeight={0} display="inline-block">
                            <MaterialTypography
                              component="label"
                              variant="caption"
                              fontWeight="bold"
                            >
                              Product Category
                            </MaterialTypography>
                          </MaterialBox>
                          <MaterialSelect
                            value={filter?.productCategory || ""}
                            onChange={(e) => {
                              setFilter((prev) => ({
                                ...prev,
                                productCategory: e,
                              }));
                            }}
                            options={filterProductOptions}
                            // menuPlacement="top"
                          />
                        </Grid>
                      </Grid>
                      <MaterialBox
                        display="flex"
                        justifyContent="flex-end"
                        mt={14}
                        gap={1}
                      >
                        <MaterialButton
                          onClick={() => setDialogOpen(false)}
                          size="small"
                          variant="gradient"
                          color="dark"
                        >
                          Cancel
                        </MaterialButton>
                        <MaterialButton
                          onClick={handleFilterSubmit}
                          variant="gradient"
                          color="dark"
                          size="small"
                        >
                          Submit
                        </MaterialButton>
                      </MaterialBox>
                    </DialogContent>
                  </Dialog>
                  {/* <MaterialBox>
                    <Tooltip
                      title="Refresh Data and Filter"
                      disableInteractive
                      color="primary"
                      componentsProps={{
                        tooltip: {
                          sx: {
                            maxWidth: 120,
                            whiteSpace: "normal",
                          },
                        },
                      }}
                    >
                      <IconButton
                        onClick={() => {
                          // fetchmalllist();
                          setFilter({
                            fromDate: "",
                            toDate: "",
                            agentId: "",
                            productCategory: "",
                          });
                        }}
                      >
                        <RefreshIcon fontSize="large" color="green" />
                      </IconButton>
                    </Tooltip>
                  </MaterialBox> */}
                </MaterialBox>

                {/* <button
                  className="container-btn-file"
                  onClick={downloadExcel}
                  style={{
                    height: "38px",
                    marginLeft: "0",
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    fontSize: "14px",
                  }}
                >
                  <svg
                    fill="#fff"
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 50 50"
                  >
                    <path d="M28.8125 .03125L.8125 5.34375C.339844 5.433594 0 5.863281 0 6.34375L0 43.65625C0 44.136719 .339844 44.566406 .8125 44.65625L28.8125 49.96875C28.875 49.980469 28.9375 50 29 50C29.230469 50 29.445313 49.929688 29.625 49.78125C29.855469 49.589844 30 49.296875 30 49L30 1C30 .703125 29.855469 .410156 29.625 .21875C29.394531 .0273438 29.105469 -.0234375 28.8125 .03125ZM32 6L32 13L34 13L34 15L32 15L32 20L34 20L34 22L32 22L32 27L34 27L34 29L32 29L32 35L34 35L34 37L32 37L32 44L47 44C48.101563 44 49 43.101563 49 42L49 8C49 6.898438 48.101563 6 47 6ZM36 13L44 13L44 15L36 15ZM6.6875 15.6875L11.8125 15.6875L14.5 21.28125C14.710938 21.722656 14.898438 22.265625 15.0625 22.875L15.09375 22.875C15.199219 22.511719 15.402344 21.941406 15.6875 21.21875L18.65625 15.6875L23.34375 15.6875L17.75 24.9375L23.5 34.375L18.53125 34.375L15.28125 28.28125C15.160156 28.054688 15.035156 27.636719 14.90625 27.03125L14.875 27.03125C14.8125 27.316406 14.664063 27.761719 14.4375 28.34375L11.1875 34.375L6.1875 34.375L12.15625 25.03125ZM36 20L44 20L44 22L36 22ZM36 27L44 27L44 29L36 29ZM36 35L44 35L44 37L36 37Z" />
                  </svg>
                  Export File
                </button> */}

                <RoleAccess
                  modelName="Product Display Compliance Screen"
                  component="UploadProductCompliance"
                >
                  <label
                    className="container-btn-file"
                    style={{
                      height: "38px",
                      marginLeft: "0",
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      fontSize: "14px",
                    }}
                    onClick={() => handleUploadClick()} // show the modal
                  >
                    <svg
                      fill="#fff"
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 50 50"
                    >
                      <path d="M28.8125 .03125L.8125 5.34375C.339844 5.433594 0 5.863281 0 6.34375L0 43.65625C0 44.136719 .339844 44.566406 .8125 44.65625L28.8125 49.96875C28.875 49.980469 28.9375 50 29 50C29.230469 50 29.445313 49.929688 29.625 49.78125C29.855469 49.589844 30 49.296875 30 49L30 1C30 .703125 29.855469 .410156 29.625 .21875C29.394531 .0273438 29.105469 -.0234375 28.8125 .03125ZM32 6L32 13L34 13L34 15L32 15L32 20L34 20L34 22L32 22L32 27L34 27L34 29L32 29L32 35L34 35L34 37L32 37L32 44L47 44C48.101563 44 49 43.101563 49 42L49 8C49 6.898438 48.101563 6 47 6ZM36 13L44 13L44 15L36 15ZM6.6875 15.6875L11.8125 15.6875L14.5 21.28125C14.710938 21.722656 14.898438 22.265625 15.0625 22.875L15.09375 22.875C15.199219 22.511719 15.402344 21.941406 15.6875 21.21875L18.65625 15.6875L23.34375 15.6875L17.75 24.9375L23.5 34.375L18.53125 34.375L15.28125 28.28125C15.160156 28.054688 15.035156 27.636719 14.90625 27.03125L14.875 27.03125C14.8125 27.316406 14.664063 27.761719 14.4375 28.34375L11.1875 34.375L6.1875 34.375L12.15625 25.03125ZM36 20L44 20L44 22L36 22ZM36 27L44 27L44 29L36 29ZM36 35L44 35L44 37L36 37Z" />
                    </svg>
                    Upload File
                  </label>
                </RoleAccess>
              </Stack>
            </Box>
          </>
        }
      />

      {uploadStatus && (
        <FileUploadModal
          key={Date.now()} // force remount
          status={uploadStatus}
          onClose={() => setUploadStatus(false)}
          onSubmit={(file) => handleExcelUpload(file)}
        />
      )}

      <ProductDisplayComplianceNew
        tabValue={value}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        setIsLoading={setIsLoading}
        isLoading={isLoading}
      />
    </DashboardLayout>
  );
};

export default ProductDisplayCompliance;
